import * as React from "react"

import type { AvatarProps } from "./types"

import { genConfig } from "./utils"

import { Face } from "./frequent-faces/face"
import { Hair } from "./frequent-faces/hair"
import { Hat } from "./frequent-faces/hat"
import { Ear } from "./frequent-faces/ear"
import { Eyebrow } from "./frequent-faces/eyebrow"
import { Eyes } from "./frequent-faces/eyes"
import { Glasses } from "./frequent-faces/glasses"
import { Nose } from "./frequent-faces/nose"
import { Mouth } from "./frequent-faces/mouth"
import { Shirt } from "./frequent-faces/shirt"

const _Avatar: React.FC<AvatarProps> = props => {
  const { id, style, shape = "circle" } = props
  const config = genConfig(props)

  // Background shape
  let borderRadius
  switch (shape) {
    case "circle": {
      borderRadius = "100%"
      break
    }
    case "rounded": {
      borderRadius = "6px"
      break
    }
    case "square": {
      borderRadius = 0
      break
    }
  }

  return (
    <div
      id={id}
      style={{
        background: config.bgColor,
        overflow: "hidden",
        borderRadius,
        ...style
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%"
        }}
      >
        <div
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            height: "90%"
          }}
        >
          <Face color={config.faceColor} />
          <Hat color={config.hatColor} style={config.hatStyle} />
          {config.hatStyle === "none" && (
            <Hair
              color={config.hairColor}
              style={config.hairStyle}
              /*  colorRandom={hairColorRandom} */
            />
          )}

          {/* Face detail */}
          <div
            style={{
              position: "absolute",
              right: "-3%",
              top: "30%",
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Eyebrow style={config.eyeBrowStyle} />
            <Eyes style={config.eyeStyle} />
            <Glasses style={config.glassesStyle} />
            <Ear color={config.faceColor} size={config.earSize} />
            <Nose style={config.noseStyle} />
            <Mouth style={config.mouthStyle} />
          </div>

          <Shirt color={config.shirtColor} style={config.shirtStyle} />
        </div>
      </div>
    </div>
  )
}

export const Avatar = React.memo(_Avatar)
